import { QueryParamAggregation } from "../../../../../services/QueryParamService";

export type QueryParamRow = QueryParamAggregation["queryParams"][number];

const HEADER = "Parameter,URL Count,Occurrences";

const FORMULA_LEADING = /^[=+\-@]/;

const neutralize = (value: string): string => (FORMULA_LEADING.test(value) ? `'${value}` : value);

const quote = (value: string): string => `"${value.replace(/"/g, '""')}"`;

const toRow = ({ paramName, urlCount, count }: QueryParamRow): string =>
  `${quote(neutralize(paramName))},${urlCount},${count}`;

export const toCsv = (params: readonly QueryParamRow[]): string => [HEADER, ...params.map(toRow)].join("\n");
